import React, { useContext } from 'react'
import { AppContext } from '../../context'
import { createPortal } from 'react-dom'

const EnlargeModal = () => {
  const { enlargeModalData, onEnlargeModalClose } = useContext(AppContext)
  return createPortal(
    <div
      className="modal"
      style={{ display: enlargeModalData.show ? 'block' : 'none' }}
    >
      <span className="close" onClick={onEnlargeModalClose}>
        &times;
      </span>
      <img
        className="modal-content"
        src={enlargeModalData.image.replace(/c_limit.*?\//i, '')}
      />
      <div id="enlarged-image-caption">{enlargeModalData.alt}</div>
    </div>,
    document.body
  )
}

export default EnlargeModal
